import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface ProductEnrichmentRun {
  id: number;
  status: string;
  queuedCount: number;
  processedCount: number;
  reviewCount: number;
  failedCount: number;
  promptTokens: number;
  completionTokens: number;
  createdAt: string;
  startedAt?: string | null;
  finishedAt?: string | null;
  message?: string | null;
}

export interface ProductEnrichmentCandidate {
  id: number;
  productId: number;
  type: string;
  field: string;
  oldValue: unknown;
  proposedValue: unknown;
  confidence: number;
  risk: 'GREEN' | 'YELLOW' | 'RED';
  status: string;
  reason?: string | null;
  evidence: Array<{ sourceType: string; source: string; excerpt?: string }>;
  product?: { id: number; description: string; article: string; brand?: { description: string } };
  selected?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ProductEnrichmentApiService {
  private readonly base = `${environment.BACKEND}/product-enrichment`;

  constructor(private readonly http: HttpClient) {}

  getRuns() {
    return this.http.get<ProductEnrichmentRun[]>(`${this.base}/runs`);
  }

  start(payload: { limit?: number; productId?: number; folderId?: number; useWeb: boolean }) {
    return this.http.post<ProductEnrichmentRun>(`${this.base}/runs`, payload);
  }

  stop(id: number) {
    return this.http.post<ProductEnrichmentRun>(`${this.base}/runs/${id}/stop`, {});
  }

  getCandidates(runId?: number, status = 'PROPOSED') {
    let params = new HttpParams().set('status', status);
    if (runId) params = params.set('runId', String(runId));
    return this.http.get<ProductEnrichmentCandidate[]>(`${this.base}/candidates`, { params });
  }

  approve(candidateIds: number[]) {
    return this.http.post<ProductEnrichmentCandidate[]>(`${this.base}/candidates/approve`, {
      candidateIds
    });
  }

  reject(candidateIds: number[]) {
    return this.http.post<ProductEnrichmentCandidate[]>(`${this.base}/candidates/reject`, {
      candidateIds
    });
  }

  publish(candidateIds: number[]) {
    return this.http.post<Array<{ id: number; published: boolean; message?: string }>>(
      `${this.base}/candidates/publish`,
      { candidateIds }
    );
  }
}
